import { STEPS } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const HowItWorks = () => (
  <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24" data-testid="how-it-works">
    <Reveal>
      <p className="text-xs font-semibold uppercase tracking-widest text-xmove-orange">Come funziona</p>
      <h2 className="mt-3 max-w-2xl font-display text-3xl font-bold text-xmove-ink sm:text-4xl">
        Dalla richiesta alle chiavi in 4 passi
      </h2>
    </Reveal>
    <div className="mt-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
      {STEPS.map((s, i) => (
        <Reveal key={s.n} delay={i * 0.1}>
          <div className="relative">
            <span className="font-display text-6xl font-bold text-xmove-orange/15">{s.n}</span>
            <h3 className="-mt-4 font-display text-lg font-bold text-xmove-ink">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-xmove-muted">{s.desc}</p>
            {i < STEPS.length - 1 && (
              <span className="absolute -right-3 top-8 hidden h-px w-6 bg-xmove-orange/30 lg:block" />
            )}
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
